export default __webpack_public_path__ + "static/media/loader-row.9d55e92f.svg";